import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { SysAdminService } from "../../../../services/sysadmin.service";

@Component({
	selector: "app-user-modify-add-roles",
	templateUrl: "./user-modify-add-roles.component.html",
	styleUrls: ["./user-modify-add-roles.component.css"],
})
export class UserModifyAddRolesComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private sysAdminService: SysAdminService) {}

	ngOnInit(): void {
		//Get data from parent
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//Get Data from DB
		this.loadRoleList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////
	UserLevelID: any = 0;
	SchoolID: any = 0;
	lstRoles: any = [];
	SelectedRoles: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "RoleDesc", header: "Role" },
		{ field: "UserLevelDesc", header: "User Level" },
	];

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadRoleList() {
		var result = this.sysAdminService.RoleWithPagesGetList(this.UserLevelID, this.SchoolID, 1);
		result.subscribe(
			(response) => {
				var Selected: any = this.dialogConfig.data.SelectedRoles;

				// console.log("List from DB");
				// console.log(response);
				// console.log("List to filter out");
				// console.log(Selected);

				var Data: any = response;

				for (var z = 0; z < Data.length; z++) {
					var next = Data[z];

					var found = false;
					for (var x = 0; x < Selected.length; x++) {
						var select = Selected[x];

						if (String(next.RoleID).toUpperCase() == String(select.RoleID).toUpperCase()) {
							found = true;
						}
					}

					if (!found) {
						this.lstRoles = [...this.lstRoles, next];
					}
				}

				// this.lstRoles = response;
				// this.UpdateSelected();
			},
			(error) => {}
		);
	}

	// UpdateSelected(){
	//   this.SelectedRoles = this.dialogConfig.data.SelectedRoles;
	// }
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.ref.close(this.SelectedRoles);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
